<input #input matInput [tabIndex]="tabIndex" [formControl]="inputCtrl" [matAutocomplete]="auto" (blur)="onBlur()">
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayName" [autoActiveFirstOption]="true"
  [panelWidth]="panelWidth" (optionSelected)="onSelect($event)" (closed)="onClosed()">
  <ng-container *ngIf="this.leadDrafts">
    <mat-option *ngIf="leadDrafts.length === 0 && !loading" disabled>{{ 'GENERAL.LEAD_NOT_FOUND' |
      translate}}</mat-option>
    <mat-option *ngFor="let leadDraft of leadDrafts" [value]="leadDraft">{{ leadDraft.companyName }}</mat-option>
  </ng-container>
</mat-autocomplete>
<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>